import React, { useState, useEffect } from 'react';
import InfoTooltip from './InfoTooltip';
import { PredictionQueue } from './components/prediction/prediction';
import InvitationSection from './components/invite/InvitationSection';
import { getRepitApplicationInfo, declineBenefit } from './activity';

import { checkRegistartionChildrenReq } from '../../../services/apiClient'; 

import './ApplicationCard.css';

import arrow_up from '../../../img/arrow-up-fill.svg';
import arrow_down from '../../../img/arrow-down-fill.svg';
import copy_icon from '../../../img/copy-icon-light.svg';

const ApplicationCard = ({ application, onEdit, onRemove, onUpdate }) => {
  const [isCertificateExpanded, setIsCertificateExpanded] = useState(false);
  const [isKindergartensExpanded, setIsKindergartensExpanded] = useState(false);
  const [isRepit, setIsRepit] = useState(false);
  const [firstApplication, setFirstApplication] = useState(null);
  const [showDeclineModal, setShowDeclineModal] = useState('');
  const [declining, setDeclining] = useState(false);

  // Определяем завершенные статусы
  const completedStatuses = ['child-in-kindergarten', 'removed', 'banned'];
  const canRemove = ['banned'];

  useEffect(()=>{
    // Не делаем запрос для завершенных заявок
    if (completedStatuses.includes(application.lastStatus)) {
      return;
    }

    async function api() {
      const result = await getRepitApplicationInfo({ birthCertificate: application.birthCertificate.seriesNumber});
      if(result.data?.data) {
        setIsRepit(result.data.data);
        
        // Находим самую первую заявку в истории
        if (result.data.data.length > 0) {
          const sortedApplications = [...result.data.data].sort((a, b) => 
            new Date(a.createdAt) - new Date(b.createdAt)
          );
          setFirstApplication(sortedApplications[0]);
        }
      }
    }

    if(application.id) api();

  },[application, application.lastStatus]) // Добавляем application.lastStatus в зависимости

  const toggleCertificate = () => {
    setIsCertificateExpanded(!isCertificateExpanded);
  };

  const toggleKindergartens = () => {
    setIsKindergartensExpanded(!isKindergartensExpanded);
  };

  const getStatusBadgeClass = (status) => {
    switch (status) {
      case 'need-check':
        return 'status-not-selected';
      case 'approved':
        return 'status-pending';
      case 'invite-accepted':
        return 'status-documents';
      case 'invite-sent':
        return 'status-documents';
      case 'child-in-kindergarten':
        return 'status-in-kindergartens';
      case 'removed':
        return 'status-removed';
      default:
        return '';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'need-check':
        return 'Садочки не обрані';
      case 'approved':
        return 'Очікуйте запрошення';
      case 'invite-sent':
        return 'Надіслане запрошення';
      case 'invite-accepted':
        return 'Надайте документи';
      case 'banned':
        return 'Заблокована';
      case 'child-in-kindergarten':
        return 'Дитина оформлена';
      case 'removed':
        return 'Заявка видалена';
      default:
        return '';
    }
  };

  // Функция для форматирования даты
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('uk');
  };



  const checkApproved = (benefits) => {
    const benefit = benefits[0];
    if(benefit?.isApproved) return true;
    return false;
  }


  const getBenefitsInfo = (benefits, queueNumber) => {
    const ben_labels = {
      UNSET: "Пільги відсутні",
      NOTUSED: "Пільги потребують веріфікації",
      USED: "Пільги підтверджені"
    }

    //if(!benefits && !benefits[0]) return ben_labels.UNSET;

    const benefit = benefits[0];

    const { benefitId, isApproved } = benefit;


    if(!benefitId) return ben_labels.UNSET;

    const isPriority = !isNaN(+(queueNumber.slice(0,2))) && (+(queueNumber.slice(0,2) < 98) ) || false;


    if(benefitId && isApproved && isPriority) return ben_labels.USED;

    return ben_labels.NOTUSED;

  }

  // Контент для инфоблока
  const cardBenefitsContent = (
    <div>
      <strong>Переваги картки киянина:</strong>
      <ul>
        <li>Пріоритет при розподілі місць у садочках</li>
        <li>Можливість отримання пільг та компенсацій</li>
        <li>Швидший доступ до міських послуг</li>
        <li>Участь у спеціальних програмах для киян</li>
      </ul>
    </div>
  );


  const ModalRemoveBenefits = ({ showDeclineModal, setShowDeclineModal, handleDeclineBenefit, declining })=>{

    
    if(!showDeclineModal) return null;

    return (
        <div
          className="modal-overlay"
          style={{ zIndex: 1060 }}
          onClick={() => !declining && setShowDeclineModal('')}
        >
          <div
            className="application-modal"
            style={{ maxWidth: 480 }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-header">
              <h2 className="modal-title">Скасування пільги</h2>
              <button
                className="close-button"
                onClick={() => setShowDeclineModal('')}
                disabled={declining}
              >
                ×
              </button>
            </div>
            
            <div className="modal-actions">
              <div className="action-buttons">
                <button
                  className="btn btn-danger"
                  onClick={handleDeclineBenefit}
                  disabled={declining}
                >
                  {declining ? 'Скасування...' : 'Підтвердити скасування'}
                </button>
              </div>
              <button
                className="btn btn-secondary"
                onClick={() => setShowDeclineModal('')}
                disabled={declining}
              >
                Закрити
              </button>
            </div>
          </div>
        </div>
      )
  }

  const handleDeclineBenefit = async () => {
    
    try {
      setDeclining(true);
      await declineBenefit(showDeclineModal);
      setShowDeclineModal('');
      onUpdate();
    } catch (err) {
      console.error('Error declining benefit:', err);
      alert('Помилка скасування пільги');
    } finally {
      setDeclining(false);
    }
  };


  const removeBenefit = (id)=>setShowDeclineModal(id);


  return (
    <div className="application-card">
      <div className="card-header">
        <div className="applicant-info">
          <h3 className="applicant-name">{application.childName}</h3>
          <div className="status-container">
            <span className={`badge ${getStatusBadgeClass(application.lastStatus)}`}>
              {getStatusText(application.lastStatus)}
            </span>
            {/* Показываем статус "Повторна" только для незавершенных заявок */}
            {!completedStatuses.includes(application.lastStatus) && isRepit && isRepit.length > 0 && (
              <span className="badge status-repit">
                Повторна
              </span>
            )}
          </div>
        </div>
        <div className="application-meta">
          <div className="application-number-info">
            <span className="application-number">{application.applicationNumber}</span>
            {/* Показываем информацию о первой заявке только для незавершенных заявок */}
            {!completedStatuses.includes(application.lastStatus) && firstApplication && (
              <div className="first-application-info">
                Перша заявка: {firstApplication.registrationNumber} від {formatDate(firstApplication.createdAt)}
              </div>
            )}
          </div>
          <button className="copy-btn" title="Копіювати">
            <img src={copy_icon} alt="copy" />
          </button>
          {application.canEdit ? (<>
            <a href="#" className="regulate-btn" onClick={onEdit}>Редагувати</a>
            <a href="#" className="regulate-btn removed-btn" onClick={(e)=>{e.preventDefault(); onRemove()}}>Видалити</a>
            </>
          ) : canRemove.includes(application.lastStatus) ? 
          <a href="#" className="regulate-btn removed-btn" onClick={(e)=>{e.preventDefault(); onRemove()}}>Видалити</a> :
          (
            <span className="status-text">
              Редагування неможливе
              <img src={copy_icon} alt="info" />
            </span>
          )}
        </div>
      </div>

      <div className="card-body">
        {/* Блок свидетельства о рождении */}
        <div className="birth-certificate-wrapper">
          <div className="birth-certificate" onClick={toggleCertificate}>
            <div className="certificate-info">
              <div className="certificate-details">
                <span className="certificate-text">
                  Свідоцтво про народження {application.birthCertificate.seriesNumber}
                </span>
                <span className="certificate-date">
                  видане {application.birthCertificate.issueDate}
                </span>
              </div>
              <img
                src={isCertificateExpanded ? arrow_up : arrow_down}
                alt="expand"
                className="expand-icon"
              />
            </div>
          </div>

          {/* Раскрывающиеся поля свидетельства */}
          {isCertificateExpanded && (
            <div className="certificate-details-expanded">
              <div className="certificate-field">
                <label>Серія та номер:</label>
                <span>{application.birthCertificate.seriesNumber}</span>
              </div>
              <div className="certificate-field">
                <label>Дата видачі:</label>
                <span>{application.birthCertificate.issueDate}</span>
              </div>
              <div className="certificate-field">
                <label>ПІБ дитини:</label>
                <span>{application.childFullName}</span>
              </div>
              <div className="certificate-field">
                <label>Дата народження:</label>
                <span>{application.birthDate}</span>
              </div>
            </div>
          )}
        </div>

        {/* Блок регистрации/картки киянина */}
        {application.registrationInfo && (
          <div className="registration-info">
            <span className="registration-text">{application.registrationInfo.text}</span>
            {(application.registrationInfo.date || true) && (
              <>
                <span className="dot-separator">•</span>
                <button  className="update-data-link" onClick={()=>checkRegistartionChildrenReq({ 
                    "fName": application.childName.trim(),
                    "birthDate": application.child.birthDate,
                    "birthCert": application.child.birthCertificate.number,
                    "lName": application.child.lastName
                }, application.id)}>Перевірити</button>
              </>
            )}
          </div>
        )}


        {(<div className="registration-info">
            <span className="registration-text">{getBenefitsInfo(application.benefits, application.queueNumber)}</span>
            {checkApproved(application.benefits) && <span className="dot-separator">•</span>}
            {checkApproved(application.benefits) && <button  className="update-data-link" onClick={()=>removeBenefit(application.id)}>Скасувати пільгу</button>}

          </div>)}

        {false && application.cardStatus && (
          <div className={`child-card-status ${application.cardStatus.confirmed ? 'confirmed' : ''}`}>
            <span className="card-status-text">{application.cardStatus.text}</span>
            {application.cardStatus.canAddData && (
              <>
                {false && <a href="#" className="add-data-link">Внести дані</a>}
                <InfoTooltip content={cardBenefitsContent}>
                  Що це дасть?
                </InfoTooltip>
              </>
            )}
            {application.cardStatus.canUpdate && (
              <>
                <span className="dot-separator">•</span>
                <a href="#" className="update-data-link">Оновити дані</a>
              </>
            )}
          </div>
        )}

        {/* Кнопка выбора садиков */}
        {application.lastStatus === 'need-check' && (
          <div className="action-button">
            <button className="select-kindergarten-btn">
              Обрати садочки
            </button>
          </div>
        )}

        {/* Блок выбранных садиков */}
        {application.selectedKindergartens && application.selectedKindergartens.count > 0 && (
          <div className="selected-kindergartens">
            <div className="application-kindergarten-header" onClick={toggleKindergartens}>
              <span className="kindergarten-count">Переглянути обрані садочки</span>
              <span className="badge kindergarten-badge">{application.selectedKindergartens.count}</span>
              {application.selectedKindergartens.needsDocuments && (
                <span className="badge documents-badge">Надайте документи</span>
              )}
              <img
                src={isKindergartensExpanded ? arrow_up : arrow_down }
                alt="expand"
                className="expand-icon"
              />
            </div>

            {/* Раскрытый список садиков */}
            {isKindergartensExpanded && application.selectedKindergartens.list && (
              <div className="application-kindergartens-list">
                {application.selectedKindergartens.list.map((kg, index) => (
                  <div key={index} className="kindergarten-item">
                    <span className="kg-name">{kg.name}</span>
                    <span className="kg-address">{kg.address}</span>
                    {kg.status && <span className={`kg-status ${kg.status}`}>{kg.statusText}</span>}
                    <PredictionQueue kg={kg} application={application}/>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
        {application.invite && ( application.isDeclinedShow || ['invite-sent', 'invite-accepted'].includes(application.lastStatus)) && (
          <InvitationSection 
            application={application}
            onStatusUpdate={onUpdate} // или другая функция для обновления статуса
          />
        )}
      </div>
      <ModalRemoveBenefits 
        showDeclineModal={showDeclineModal} 
        setShowDeclineModal={setShowDeclineModal}
        handleDeclineBenefit={handleDeclineBenefit}
        declining={declining} 
      />
    </div>
  );
};

export default ApplicationCard;